import { useQuery } from "react-query";
import { schedulingQuery } from "../../lib/schedulingCache";

export function useSchedulingQuery(key, queryFn, options) {
  return useQuery(key, schedulingQuery(queryFn), options);
}
